import React from 'react';
import {Modal, Text, Icon, StatusBadge} from '@/ui-kits';
import {SupportTicket} from '@/interface';
import { HelpRequestStatusBadgeVariants, HelpRequestStatusLabels } from '@/constants';
import { HelpRequestStatus } from '@/constants/enums';

interface SpamStatusModalProps {
  open: boolean;
  onClose: () => void;
  ticket: SupportTicket;
}

export const SpamStatusModal: React.FC<SpamStatusModalProps> = ({
  open,
  onClose,
  ticket,
}) => {

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="relative bg-white py-4 px-6 rounded-xl gap-6 w-[90vw] max-w-[700px] max-h-[90vh] overflow-y-auto">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 size-8 flex items-center justify-center rounded-full hover:bg-gray-100">
        <Icon type="close" className="size-5 text-ui_blue" />
      </button>

      {/* Header Section */}
      <div className="flex items-center gap-4 mb-6">
        <Text variant="free" className="text-ui_blue font-FigtreeBold text-3xl">
          {String(ticket.id)}
        </Text>
        <StatusBadge variant="secondary" status={HelpRequestStatusBadgeVariants[ticket?.status as HelpRequestStatus]}>
          {HelpRequestStatusLabels[ticket?.status as HelpRequestStatus]}
        </StatusBadge>
      </div>

      {/* User Message Section */}
      <div className="mb-6">
        <Text variant="body" className="!text-deep_blue !font-FigtreeSemiBold mb-3 !text-xl">
          User Message
        </Text>
        <div className="bg-ui_user_message_bg/5 rounded-lg p-4 border border-ui_input_border">
          <Text variant="body" className="text-ui_blue whitespace-pre-wrap">
            {ticket.user_message || 'No message provided'}
          </Text>
        </div>
      </div>
    </Modal>
  );
};

